var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tms-anchor",class:_vm.isEditorStatus ? '' : 'height0',attrs:{"id":_vm.config.property_data.anchor_name}},[_c('span',[_vm._v("我是锚点，点击设置，最终页面上不会呈现我")])])}
var staticRenderFns = []

export { render, staticRenderFns }